function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useCallback, useEffect, useRef, useState } from 'react';
import Hls from 'hls.js';
// 개발 환경 여부 확인
var isDevelopment = process.env.NODE_ENV === 'development';
export function useHlsPlayer(param) {
    var videoElement = param.videoElement, src = param.src, _param_autoPlay = param.autoPlay, autoPlay = _param_autoPlay === void 0 ? false : _param_autoPlay, onError = param.onError, onLoadedData = param.onLoadedData, _param_maxRetries = param.maxRetries, maxRetries = _param_maxRetries === void 0 ? 3 : _param_maxRetries;
    // --- Refs ---
    var hlsInstanceRef = useRef(null);
    var retryCountRef = useRef(0);
    var onErrorRef = useRef(onError);
    var onLoadedDataRef = useRef(onLoadedData);
    // videoElement는 prop으로 받지만 내부에서 직접 사용하지 않고, effect의 trigger로만 사용
    var configRef = useRef({
        debug: isDevelopment,
        enableWorker: true,
        // 안정성 위주 설정
        lowLatencyMode: false,
        backBufferLength: 90,
        maxBufferLength: 120,
        maxMaxBufferLength: 600,
        maxBufferSize: 60 * 1000 * 1000,
        // 네트워크 타임아웃 및 재시도 설정 강화
        manifestLoadingTimeOut: 20000,
        manifestLoadingMaxRetry: 4,
        manifestLoadingRetryDelay: 1000,
        levelLoadingTimeOut: 20000,
        levelLoadingMaxRetry: 4,
        levelLoadingRetryDelay: 1000,
        fragLoadingTimeOut: 30000,
        fragLoadingMaxRetry: 5,
        fragLoadingRetryDelay: 1000,
        // 버퍼 관련 설정 (네트워크 불안정 시 도움될 수 있음)
        maxBufferHole: 2.0,
        maxSeekHole: 2.5,
        xhrSetup: function(xhr) {
            console.log('[useHlsPlayer] xhrSetup executing...');
            xhr.withCredentials = true;
            xhr.timeout = 30000; // XHR 타임아웃 (30초) - fragLoadingTimeOut과 연관
            xhr.setRequestHeader('Accept', 'application/vnd.apple.mpegurl, */*');
        }
    });
    // --- State ---
    var _useState = _sliced_to_array(useState(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), error = _useState1[0], setError = _useState1[1];
    var _useState2 = _sliced_to_array(useState(function() {
        var supported = Hls.isSupported();
        console.log("[useHlsPlayer] Initial HLS support check: ".concat(supported));
        return supported;
    }), 2), isHlsSupported = _useState2[0], setIsHlsSupported = _useState2[1];
    // --- Update refs when props change ---
    useEffect(function() {
        console.log('[useHlsPlayer] Updating prop refs...');
        onErrorRef.current = onError;
        onLoadedDataRef.current = onLoadedData;
    // autoPlayRef 제거 (직접 사용하지 않음)
    }, [
        onError,
        onLoadedData
    ]);
    // --- Utility Functions ---
    var isHlsUrl = useCallback(function(url) {
        if (!url) return false;
        var lowerUrl = url.toLowerCase();
        return lowerUrl.endsWith('.m3u8') || lowerUrl.includes('/hls/');
    }, []);
    // --- Core Effect for HLS Management ---
    useEffect(function() {
        console.log("[useHlsPlayer] Core Effect Triggered. Props: src='".concat(src, "', videoElement? ").concat(!!videoElement));
        if (!videoElement || !src) {
            console.warn('[useHlsPlayer] Core Effect: Bailing out - videoElement or src is missing.');
            if (hlsInstanceRef.current) {
                console.log('[useHlsPlayer] Cleaning up existing HLS instance (bail out).');
                hlsInstanceRef.current.destroy();
                hlsInstanceRef.current = null;
            }
            setLoading(false); // Ensure loading is false if bailing out
            setError(null);
            return;
        }
        var shouldManageHls = isHlsUrl(src);
        console.log("[useHlsPlayer] Core Effect: isHlsUrl=".concat(shouldManageHls, ", isHlsSupported=").concat(isHlsSupported));
        if (shouldManageHls) {
            if (isHlsSupported) {
                console.log('[useHlsPlayer] Attempting HLS setup...');
                setLoading(true);
                setError(null);
                retryCountRef.current = 0;
                // Destroy previous instance BEFORE creating a new one
                if (hlsInstanceRef.current) {
                    console.log('[useHlsPlayer] Destroying previous HLS instance before creating new one.');
                    hlsInstanceRef.current.destroy();
                    hlsInstanceRef.current = null; // Ensure ref is nullified
                }
                try {
                    // Ensure videoElement is still valid before creating Hls instance
                    if (!videoElement) {
                        console.warn('[useHlsPlayer] videoElement became null before HLS instance creation.');
                        setLoading(false);
                        return; // Prevent HLS creation if element disappeared
                    }
                    console.log('[useHlsPlayer] Creating new Hls instance with config:', configRef.current);
                    var hls = new Hls(configRef.current);
                    hlsInstanceRef.current = hls;
                    console.log('[useHlsPlayer] New HLS instance created.');
                    var internalOnError = function(_event, data) {
                        var _data_details, _data_details1, _data_response_text, _data_response, _data_response_text1, _data_response1, _onErrorRef_current;
                        console.error('[useHlsPlayer] HLS.Events.ERROR received:', data);
                        // CORS 오류 처리 등... (handleHlsError 로직과 유사하게 구현)
                        var HlsErrorTypes = Hls === null || Hls === void 0 ? void 0 : Hls.ErrorTypes;
                        var errorMessage = "HLS 오류: ".concat(data.details || '알 수 없는 오류');
                        var isFatal = data.fatal;
                        if (((_data_details = data.details) === null || _data_details === void 0 ? void 0 : _data_details.includes('cors')) || ((_data_details1 = data.details) === null || _data_details1 === void 0 ? void 0 : _data_details1.includes('access')) || ((_data_response = data.response) === null || _data_response === void 0 ? void 0 : (_data_response_text = _data_response.text) === null || _data_response_text === void 0 ? void 0 : _data_response_text.includes('CORS')) || ((_data_response1 = data.response) === null || _data_response1 === void 0 ? void 0 : (_data_response_text1 = _data_response1.text) === null || _data_response_text1 === void 0 ? void 0 : _data_response_text1.includes('cross-origin'))) {
                            errorMessage = "CORS 오류: 스트리밍 서버(".concat(data.url || src, ")에 접근할 수 없습니다.");
                            isFatal = true; // CORS는 치명적 오류로 간주
                        }
                        if (isFatal && HlsErrorTypes) {
                            switch(data.type){
                                case HlsErrorTypes.NETWORK_ERROR:
                                    if (retryCountRef.current < maxRetries) {
                                        var _hlsInstanceRef_current;
                                        retryCountRef.current++;
                                        console.warn("HLS 네트워크 오류, 재시도 ".concat(retryCountRef.current, "/").concat(maxRetries));
                                        (_hlsInstanceRef_current = hlsInstanceRef.current) === null || _hlsInstanceRef_current === void 0 ? void 0 : _hlsInstanceRef_current.startLoad();
                                        return; // 재시도 시 에러 상태 업데이트 및 콜백 호출 방지
                                    } else {
                                        errorMessage = "네트워크 오류: 비디오를 로드할 수 없습니다(".concat(retryCountRef.current, "번 재시도 실패).");
                                    }
                                    break;
                                case HlsErrorTypes.MEDIA_ERROR:
                                    if (retryCountRef.current < maxRetries && data.details !== 'bufferStalledError') {
                                        var _hlsInstanceRef_current1;
                                        retryCountRef.current++;
                                        console.warn("HLS 미디어 오류(".concat(data.details, "), 재시도 ").concat(retryCountRef.current, "/").concat(maxRetries));
                                        (_hlsInstanceRef_current1 = hlsInstanceRef.current) === null || _hlsInstanceRef_current1 === void 0 ? void 0 : _hlsInstanceRef_current1.recoverMediaError();
                                        return; // 재시도 시 에러 상태 업데이트 및 콜백 호출 방지
                                    } else {
                                        errorMessage = "미디어 오류(".concat(data.details, "): 비디오를 재생할 수 없습니다.");
                                    }
                                    break;
                            }
                        }
                        setError(errorMessage);
                        setLoading(false);
                        console.log("[useHlsPlayer] Calling onErrorRef.current with: ".concat(errorMessage));
                        (_onErrorRef_current = onErrorRef.current) === null || _onErrorRef_current === void 0 ? void 0 : _onErrorRef_current.call(onErrorRef, errorMessage);
                    };
                    var internalOnManifestParsed = function() {
                        var _onLoadedDataRef_current;
                        console.log('[useHlsPlayer] HLS.Events.MANIFEST_PARSED received.');
                        setLoading(false);
                        setError(null);
                        console.log('[useHlsPlayer] Calling onLoadedDataRef.current');
                        (_onLoadedDataRef_current = onLoadedDataRef.current) === null || _onLoadedDataRef_current === void 0 ? void 0 : _onLoadedDataRef_current.call(onLoadedDataRef);
                    // Auto-play logic removed - handled by useVideoPlayer based on visibility
                    };
                    // Log before attaching listeners
                    console.log('[useHlsPlayer] Attaching HLS event listeners...');
                    hls.on(Hls.Events.ERROR, internalOnError);
                    hls.on(Hls.Events.MANIFEST_PARSED, internalOnManifestParsed);
                    // Log before loading source and attaching media
                    console.log("[useHlsPlayer] Loading source: ".concat(src));
                    hls.loadSource(src);
                    console.log('[useHlsPlayer] Attaching media to video element...');
                    hls.attachMedia(videoElement);
                    console.log('[useHlsPlayer] HLS setup complete.');
                } catch (initError) {
                    var _onErrorRef_current;
                    console.error('[useHlsPlayer] HLS initialization failed:', initError);
                    var initErrorMessage = "HLS 초기화 실패: ".concat(initError.message);
                    setError(initErrorMessage);
                    setLoading(false);
                    (_onErrorRef_current = onErrorRef.current) === null || _onErrorRef_current === void 0 ? void 0 : _onErrorRef_current.call(onErrorRef, initErrorMessage);
                    if (hlsInstanceRef.current) {
                        hlsInstanceRef.current.destroy();
                        hlsInstanceRef.current = null;
                    }
                }
            } else {
                var _onErrorRef_current1;
                console.warn('[useHlsPlayer] HLS URL detected, but HLS is not supported.');
                var noSupportMsg = '이 브라우저는 HLS 스트리밍을 지원하지 않습니다.';
                setError(noSupportMsg);
                setLoading(false);
                (_onErrorRef_current1 = onErrorRef.current) === null || _onErrorRef_current1 === void 0 ? void 0 : _onErrorRef_current1.call(onErrorRef, noSupportMsg);
                if (hlsInstanceRef.current) {
                    hlsInstanceRef.current.destroy();
                    hlsInstanceRef.current = null;
                }
            }
        } else {
            console.log('[useHlsPlayer] Not an HLS URL. Cleaning up any existing HLS instance.');
            if (hlsInstanceRef.current) {
                hlsInstanceRef.current.destroy();
                hlsInstanceRef.current = null;
            }
            setLoading(false);
            setError(null);
        }
        // --- Cleanup Function ---
        return function() {
            console.log('[useHlsPlayer] Cleanup function running.');
            if (hlsInstanceRef.current) {
                console.log('[useHlsPlayer] Destroying HLS instance in cleanup.');
                hlsInstanceRef.current.destroy();
                hlsInstanceRef.current = null;
            }
        };
    // 의존성 배열 수정: videoElement, src, isHlsSupported 만 포함
    // isHlsUrl, maxRetries는 변경 가능성이 거의 없으므로 제거해도 무방하나, 안전하게 포함.
    // 콜백 함수들은 Ref로 관리되므로 제거.
    }, [
        videoElement,
        src,
        isHlsSupported,
        isHlsUrl,
        maxRetries
    ]);
    return {
        loading: loading,
        error: error
    };
}
